import '../assets/css/skills.css';
import '../assets/css/slideText.css';

import { useEffect, useRef, useState } from 'react';
import javascript from '../assets/images/skills/Javascript-Logo.png';
import nodeJs from '../assets/images/skills/NodeJs-Logo.png';
import expressJs from '../assets/images/skills/ExpressJs-Logo.png';
import restApi from '../assets/images/skills/REST-APIs-Logo.png';
import graphQL from '../assets/images/skills/GraphQL-Logo.png';
import reactJs from '../assets/images/skills/ReactJs-Logo.png';
import openLayers from '../assets/images/skills/OpenLayers-Logo.png';
import html from '../assets/images/skills/HTML-Logo.png';
import css from '../assets/images/skills/CSS-Logo.png';
import bootsrap from '../assets/images/skills/Bootsrap-Logo.png';
import mySQL from '../assets/images/skills/MySQL-Logo.png';
import mongoDB from '../assets/images/skills/MongoDB-Logo.png';
import postgreSQL from '../assets/images/skills/PostgreSQL-Logo.png';
import aws from '../assets/images/skills/AWS-Logo.png';
import ec2 from '../assets/images/skills/AWS-EC2-Logo.png';
import s3 from '../assets/images/skills/AWS-S3-Logo.png';
import lamda from '../assets/images/skills/AWS-Lamda-Logo.png';
import git from '../assets/images/skills/Git-Logo.png';
import gitHub from '../assets/images/skills/GitHub-Logo.png';
import cicd from '../assets/images/skills/CI-CD-Logo.png';
import postman from '../assets/images/skills/Postman-Logo.png';
import geoServer from '../assets/images/skills/GeoServer-Logo.png';
import pgAdmin from '../assets/images/skills/PgAdmin-Logo.png';
import xampp from '../assets/images/skills/Xampp-Logo.png';
import vsCode from '../assets/images/skills/VisualStudioCode-Logo.png';
import python from '../assets/images/skills/Python-Logo.png';
import php from '../assets/images/skills/PHP-Logo.png';
import codeigniter from '../assets/images/skills/Codeigniter-Log.png';
import laravel from '../assets/images/skills/Laravel-Logo.png';
import java from '../assets/images/skills/Java-Logo.png';


const Skills = () => {

    // const BackendCirclesRef = useRef([]);
    // const DatabaseCirclesRef = useRef([]);
    // const DevOpsCirclesRef = useRef([]);
    // const ToolsCirclesRef = useRef([]);

    const getRandomHexColor = () => {
        return `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
    }

    const skillCircles = {
        Frontend: [
            { name: "HTML", percent: 99, color: getRandomHexColor(), 'logo': html },
            { name: "CSS", percent: 90, color: getRandomHexColor(), 'logo': css },
            { name: "JavaScript", percent: 99, color: getRandomHexColor(), 'logo': javascript },
            { name: "ReactJs", percent: 99, color: getRandomHexColor(), 'logo': reactJs },
            { name: "Bootsrap", percent: 90, color: getRandomHexColor(), 'logo': bootsrap },
            { name: "OpenLayers", percent: 80, color: getRandomHexColor(), 'logo': openLayers },
        ],
        Backend: [
            { name: "PHP", percent: 95, color: getRandomHexColor(), 'logo': php },
            { name: "Codeigniter", percent: 99, color: getRandomHexColor(), 'logo': codeigniter },
            { name: "Laravel", percent: 85, color: getRandomHexColor(), 'logo': laravel },
            { name: "NodeJs", percent: 80, color: getRandomHexColor(), 'logo': nodeJs },
            { name: "ExpressJs", percent: 80, color: getRandomHexColor(), 'logo': expressJs },
            { name: "REST-APIs", percent: 99, color: getRandomHexColor(), 'logo': restApi },
            { name: "GraphQL", percent: 90, color: getRandomHexColor(), 'logo': graphQL },
            { name: "Python", percent: 70, color: getRandomHexColor(), 'logo': python },
            { name: "Java", percent: 80, color: getRandomHexColor(), 'logo': java },
            { name: "Xampp", percent: 95, color: getRandomHexColor(), 'logo': xampp },

        ],
        Database: [
            { name: "MySQL", percent: 99, color: getRandomHexColor(), 'logo': mySQL },
            { name: "MongoDB", percent: 90, color: getRandomHexColor(), 'logo': mongoDB },
            { name: "PostgreSQL", percent: 80, color: getRandomHexColor(), 'logo': postgreSQL },
            { name: "PgAdmin", percent: 90, color: getRandomHexColor(), 'logo': pgAdmin },
        ],
        DevOps: [
            { name: "AWS", percent: 80, color: getRandomHexColor(), 'logo': aws },
            { name: "AWS-EC2", percent: 80, color: getRandomHexColor(), 'logo': ec2 },
            { name: "AWS-S3", percent: 70, color: getRandomHexColor(), 'logo': s3 },
            { name: "AWS-Lamda", percent: 60, color: getRandomHexColor(), 'logo': lamda },
            { name: "GIT", percent: 99, color: getRandomHexColor(), 'logo': git },
            { name: "GitHub", percent: 99, color: getRandomHexColor(), 'logo': gitHub },
            { name: "CI/CD", percent: 99, color: getRandomHexColor(), 'logo': cicd },
            { name: "Postman", percent: 99, color: getRandomHexColor(), 'logo': postman },
            { name: "GeoServer", percent: 90, color: getRandomHexColor(), 'logo': geoServer },
        ],
        Tools: [
            { name: "VsCode", percent: 99, color: getRandomHexColor(), 'logo': vsCode },
        ]
    };

    const circlesRef = useRef({
        Frontend: [],
        Backend: [],
        Database: [],
        DevOps: [],
        Tools: []
    });

    const container2Ref = useRef(null);
    const skillsGroupContainerRef = useRef([]);

    const [frontendPercentCount, setFrontendPercentCount] = useState(skillCircles.Frontend.map((skill, i) => 0));
    const [backendPercentCount, setBackendPercentCount] = useState(skillCircles.Backend.map((skill, i) => 0));
    const [databasePercentCount, setDatabasePercentCount] = useState(skillCircles.Database.map((skill, i) => 0));
    const [devOpsPercentCount, setDevOpsPercentCount] = useState(skillCircles.DevOps.map((skill, i) => 0));
    const [toolsPercentCount, setToolsPercentCount] = useState(skillCircles.Tools.map((skill, i) => 0));

    let frontendAnimation = 0;
    let backendAnimation = 0;
    let databasedAnimation = 0;
    let DevOpsAnimation = 0;
    let toolsAnimation = 0;


    const handleScrollFrontend = () => {

        if (frontendAnimation == 0) {

            circlesRef.current.Frontend.forEach(function (progress, index) {

                const position = skillsGroupContainerRef.current[0].getBoundingClientRect().top;
                const windowHeight = window.innerHeight;
                const e_height = skillsGroupContainerRef.current[0].offsetHeight;
                // const e_width = skillsGroupContainerRef.current[0].offsetWidth;


                // if (position < (windowHeight - e_height) && position > (-e_height)) {
                if (position < (windowHeight - 300) && position > (-e_height)) {
                    frontendAnimation = 1;
                    let degree = 0;
                    let targetDegree = parseInt(progress.getAttribute('data-degree'));
                    let color = progress.getAttribute('data-color');

                    let numberH2ElementObj = progress.querySelector('.number');

                    let interval = setInterval(function () {
                        degree += 1;
                        if (degree > targetDegree) {
                            clearInterval(interval);
                            return;
                        }
                        progress.style.background = `conic-gradient(${color} ${degree}%, #222 0%)`;
                        numberH2ElementObj.innerHTML = degree;

                    }, 50);

                }

            });

        }

    };

    const handleScrollBackend = () => {
        if (backendAnimation == 0) {

            circlesRef.current.Backend.forEach(function (progress, index) {

                const position = skillsGroupContainerRef.current[1].getBoundingClientRect().top;
                const windowHeight = window.innerHeight;
                const e_height = skillsGroupContainerRef.current[1].offsetHeight;

                let degree = 0;
                let targetDegree = parseInt(progress.getAttribute('data-degree'));
                let color = progress.getAttribute('data-color');
                let numberH2ElementObj = progress.querySelector('.number');

                // if (position < (windowHeight - e_height) && position > (-e_height)) {
                if (position < (windowHeight - 300) && position > (-e_height)) {
                    backendAnimation = 1;
                    let interval = setInterval(function () {
                        degree += 1;
                        if (degree > targetDegree) {
                            clearInterval(interval);
                            return;
                        }
                        progress.style.background = `conic-gradient(${color} ${degree}%, #222 0%)`;
                        numberH2ElementObj.innerHTML = degree;

                    }, 50);

                }

            });
        }
    };

    const handleScrollDatabase = () => {

        if (databasedAnimation == 0) {


            circlesRef.current.Database.forEach(function (progress, index) {

                const position = skillsGroupContainerRef.current[2].getBoundingClientRect().top;
                const windowHeight = window.innerHeight;
                const e_height = skillsGroupContainerRef.current[2].offsetHeight;

                let degree = 0;
                let targetDegree = parseInt(progress.getAttribute('data-degree'));
                let color = progress.getAttribute('data-color');
                let numberH2ElementObj = progress.querySelector('.number');

                // if (position < (windowHeight - e_height) && position > (-e_height)) {
                if (position < (windowHeight - 300) && position > (-e_height)) {

                    databasedAnimation = 1;

                    let interval = setInterval(function () {
                        degree += 1;
                        if (degree > targetDegree) {
                            clearInterval(interval);
                            return;
                        }
                        progress.style.background = `conic-gradient(${color} ${degree}%, #222 0%)`;
                        numberH2ElementObj.innerHTML = degree;

                    }, 50);

                }

            });

        }

    };

    const handleScrollDevOps = () => {

        if (DevOpsAnimation == 0) {

            circlesRef.current.DevOps.forEach(function (progress, index) {

                const position = skillsGroupContainerRef.current[3].getBoundingClientRect().top;
                const windowHeight = window.innerHeight;
                const e_height = skillsGroupContainerRef.current[3].offsetHeight;

                let degree = 0;
                let targetDegree = parseInt(progress.getAttribute('data-degree'));
                let color = progress.getAttribute('data-color');
                let numberH2ElementObj = progress.querySelector('.number');

                // if (position < (windowHeight - e_height) && position > (-e_height)) {
                if (position < (windowHeight - 300) && position > (-e_height)) {

                    DevOpsAnimation = 1;
                    let interval = setInterval(function () {
                        degree += 1;
                        if (degree > targetDegree) {
                            clearInterval(interval);
                            return;
                        }
                        progress.style.background = `conic-gradient(${color} ${degree}%, #222 0%)`;
                        numberH2ElementObj.innerHTML = degree;

                    }, 50);

                }

            });

        }

    };

    const handleScrollTools = () => {

        if (toolsAnimation == 0) {

            circlesRef.current.Tools.forEach(function (progress, index) {

                const position = skillsGroupContainerRef.current[4].getBoundingClientRect().top;
                const windowHeight = window.innerHeight;
                const e_height = skillsGroupContainerRef.current[4].offsetHeight;

                let degree = 0;
                let targetDegree = parseInt(progress.getAttribute('data-degree'));
                let color = progress.getAttribute('data-color');
                let numberH2ElementObj = progress.querySelector('.number');

                // if (position < (windowHeight - e_height) && position > (-e_height)) {
                if (position < (windowHeight - 300) && position > (-e_height)) {

                    toolsAnimation = 1;
                    let interval = setInterval(function () {
                        degree += 1;
                        if (degree > targetDegree) {
                            clearInterval(interval);
                            return;
                        }
                        progress.style.background = `conic-gradient(${color} ${degree}%, #222 0%)`;
                        numberH2ElementObj.innerHTML = degree;

                    }, 50);

                }

            });

        }

    };


    const handleScroll = () => {
        handleScrollFrontend();
        handleScrollBackend();
        handleScrollDatabase();
        handleScrollDevOps();
        handleScrollTools();
    }

    const handleScroll2 = () => {

        let tempFrontendPercentCount = [...frontendPercentCount];


        let tempBackendPercentCount = [...backendPercentCount];

        let tempDatabasePercentCount = [...databasePercentCount];

        let tempDevOpsPercentCount = [...devOpsPercentCount];

        let tempToolsPercentCount = [...toolsPercentCount];

        Object.keys(circlesRef.current).map((skillGroup, index0) => {

            circlesRef.current[skillGroup].forEach(function (progress, index) {

                const position = progress.getBoundingClientRect().top;
                const windowHeight = window.innerHeight;
                const e_height = progress.offsetHeight;

                let degree = 0;
                let targetDegree = parseInt(progress.getAttribute('data-degree'));
                let color = progress.getAttribute('data-color');

                if (position < (windowHeight - e_height) && position > (-e_height)) {


                    let interval = setInterval(function () {
                        degree += 1;
                        if (degree > targetDegree) {
                            clearInterval(interval);
                            return;
                        }


                        if (skillGroup == 'Frontend') {
                            progress.style.background = `conic-gradient(${color} ${degree}%, #222 0%)`;
                            tempFrontendPercentCount[index] = degree;
                            setFrontendPercentCount(tempFrontendPercentCount);
                        }
                        else if (skillGroup == 'Backend') {
                            progress.style.background = `conic-gradient(${color} ${degree}%, #222 0%)`;
                            tempBackendPercentCount[index] = degree;
                            setBackendPercentCount(tempBackendPercentCount);
                        }
                        else if (skillGroup == 'Database') {
                            progress.style.background = `conic-gradient(${color} ${degree}%, #222 0%)`;
                            tempDatabasePercentCount[index] = degree;
                            setDatabasePercentCount(tempDatabasePercentCount);
                        }
                        else if (skillGroup == 'DevOps') {
                            progress.style.background = `conic-gradient(${color} ${degree}%, #222 0%)`;
                            tempDevOpsPercentCount[index] = degree;
                            setDevOpsPercentCount(tempDevOpsPercentCount);
                        }
                        else if (skillGroup == 'Tools') {
                            progress.style.background = `conic-gradient(${color} ${degree}%, #222 0%)`;
                            tempToolsPercentCount[index] = degree;
                            setToolsPercentCount(tempToolsPercentCount);
                        }

                    }, 50);

                }
                else {
                    degree = 0;
                    if (skillGroup == 'Frontend') {
                        progress.style.background = `conic-gradient(${color} ${degree}%, #222 0%)`;
                        tempFrontendPercentCount[index] = degree;
                        setFrontendPercentCount(tempFrontendPercentCount);
                    }
                    else if (skillGroup == 'Backend') {
                        progress.style.background = `conic-gradient(${color} ${degree}%, #222 0%)`;
                        tempBackendPercentCount[index] = degree;
                        setBackendPercentCount(tempBackendPercentCount);
                    }
                    else if (skillGroup == 'Database') {
                        progress.style.background = `conic-gradient(${color} ${degree}%, #222 0%)`;
                        tempDatabasePercentCount[index] = degree;
                        setDatabasePercentCount(tempDatabasePercentCount);
                    }
                    else if (skillGroup == 'DevOps') {
                        progress.style.background = `conic-gradient(${color} ${degree}%, #222 0%)`;
                        tempDevOpsPercentCount[index] = degree;
                        setDevOpsPercentCount(tempDevOpsPercentCount);
                    }
                    else if (skillGroup == 'Tools') {
                        progress.style.background = `conic-gradient(${color} ${degree}%, #222 0%)`;
                        tempToolsPercentCount[index] = degree;
                        setToolsPercentCount(tempToolsPercentCount);
                    }
                }


            });

        });

    };

    useEffect(() => {

        container2Ref.current.addEventListener('scroll', handleScroll);

        // Cleanup event listener on component unmount
        return () => {
            if (container2Ref != null) {
                if (container2Ref.current != null) {
                    container2Ref.current.removeEventListener('scroll', handleScroll);
                }
            }
        };

    }, []);


    return (
        <>

            <div className="skills-container">
                <h1 className="heading">Skills</h1>
                <div className="container2" ref={(el) => (container2Ref.current = el)}>

                    {
                        Object.keys(skillCircles).map((skillGroup, index0) => {

                            return (
                                <div className="skills-group-container" ref={(el) => (skillsGroupContainerRef.current[index0] = el)}>
                                    <div className="skills-group-title-container"><span className="skills-group-title">{skillGroup}</span></div>
                                    {
                                        skillCircles[skillGroup].map((skill, index) => {
                                            return (
                                                <div className="circle" data-degree={skill.percent} data-color={skill.color} ref={(el) => (circlesRef.current[skillGroup][index] = el)}>
                                                    <h2 className="number"  >0<span>%</span></h2>
                                                    <h4 style={{ 'color': '#fff' }}>{skill.name}</h4>
                                                    <img src={skill.logo} alt={skill.name} />
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            )

                        })
                    }

                </div>

            </div>
        </>
    );
}

export default Skills;